function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//@ts-nocheck
import React from 'react';
import { Grid, Typography, Card, CardContent, Box, LinearProgress, Button, FormControl, Select, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import { Link } from 'react-router-dom';

// Customizable Area Start

import { pageLoader } from './utility';
// Customizable Area End

const RunningIcon = require('../assets/running.png');
const StoppedIcon = require('../assets/stopped.png');
export class DeviceStats extends BlockComponent {
  constructor(props) {
    super(props);
    //Customizable Area Start
    this.state = {
      // flow: '0.00',
      // speed: '0.00',
      // load: '0.00',
      // total: '0.00 t',
      runningStatus: false,
      lastUpdatedOn: Math.round(+new Date() / 1000),
      deviceIndex: 0,
      timed: false
      // deviceDetails: {
      //   sid_name: "",
      //   classes: "",
      //   deviceTargetFlow: "",
      //   deviceTargetSpeed: "", deviceTargetLoad: "", sid: ""
      // }
    };
    //Customizable Area End
  }
  async componentDidMount() {
    super.componentDidMount();
    this.interval = setInterval(() => this.tick(), 1000);
    if (!this.state.timed) {
      setTimeout(() => this.setState({
        timed: true
      }), 30000);
    }
    // this.getMqttData();
  }
  async componentWillUnmount() {
    clearInterval(this.interval);
  }
  tick() {
    const now = Math.round(+new Date() / 1000);
    const {
      lastUpdatedOn
    } = this.state;
    if (now - lastUpdatedOn >= 300) {
      console.log('5 miuntes of inactivity. Machine is STOPPED!');
      this.setState(state => ({
        runningStatus: false
      }));
    }
  }
  changeIndex(event, change) {
    if (event && change) {
      event.preventDefault();
      change >= 0 && this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        deviceIndex: change
      }));
    }
  }
  render() {
    var _this$state, _this$state2, _subDevice$mqttData;
    const {
      modemDetails,
      classes
    } = this.props;
    let startedDevice = false;
    const locationName = Object.keys(modemDetails)[0];
    const devices = Object.values(modemDetails)[0];
    const deviceImeiNumber = devices[(_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.deviceIndex].imei;
    const subDevice = devices.length > 0 ? devices[(_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.deviceIndex] : {};
    // console.log(subDevice);
    const {
      sub_device
    } = subDevice;
    let deviceFlow, deviceSpeed, deviceLoad, deviceTotal, disconnected;
    if (subDevice !== null && subDevice !== void 0 && subDevice.mqttData && (subDevice === null || subDevice === void 0 || (_subDevice$mqttData = subDevice.mqttData) === null || _subDevice$mqttData === void 0 || (_subDevice$mqttData = _subDevice$mqttData.modbus) === null || _subDevice$mqttData === void 0 ? void 0 : _subDevice$mqttData.length) > 1) {
      var _subDevice$mqttData2;
      // devices[this.state.deviceIndex].sub_device.sid
      subDevice === null || subDevice === void 0 || (_subDevice$mqttData2 = subDevice.mqttData) === null || _subDevice$mqttData2 === void 0 || (_subDevice$mqttData2 = _subDevice$mqttData2.modbus) === null || _subDevice$mqttData2 === void 0 || _subDevice$mqttData2.map(multiSubItem => {
        if (multiSubItem.sid == devices[this.state.deviceIndex].sub_device.sid) {
          var _multiSubItem$Flow, _multiSubItem$Speed, _multiSubItem$Load, _multiSubItem$Total;
          deviceFlow = (_multiSubItem$Flow = multiSubItem.Flow) !== null && _multiSubItem$Flow !== void 0 ? _multiSubItem$Flow : '0.00';
          deviceSpeed = (_multiSubItem$Speed = multiSubItem.Speed) !== null && _multiSubItem$Speed !== void 0 ? _multiSubItem$Speed : '0.00';
          deviceLoad = (_multiSubItem$Load = multiSubItem.Load) !== null && _multiSubItem$Load !== void 0 ? _multiSubItem$Load : '0.00';
          deviceTotal = (_multiSubItem$Total = multiSubItem.Total) !== null && _multiSubItem$Total !== void 0 ? _multiSubItem$Total : '0.00';
          disconnected = multiSubItem.disconnected;
          return true;
        }
      });
    } else {
      var _subDevice$mqttData$m, _subDevice$mqttData3, _subDevice$mqttData$m2, _subDevice$mqttData4, _subDevice$mqttData$m3, _subDevice$mqttData5, _subDevice$mqttData$m4, _subDevice$mqttData6, _subDevice$mqttData7;
      deviceFlow = (_subDevice$mqttData$m = subDevice === null || subDevice === void 0 || (_subDevice$mqttData3 = subDevice.mqttData) === null || _subDevice$mqttData3 === void 0 || (_subDevice$mqttData3 = _subDevice$mqttData3.modbus[0]) === null || _subDevice$mqttData3 === void 0 ? void 0 : _subDevice$mqttData3.Flow) !== null && _subDevice$mqttData$m !== void 0 ? _subDevice$mqttData$m : '0.00';
      deviceSpeed = (_subDevice$mqttData$m2 = subDevice === null || subDevice === void 0 || (_subDevice$mqttData4 = subDevice.mqttData) === null || _subDevice$mqttData4 === void 0 || (_subDevice$mqttData4 = _subDevice$mqttData4.modbus[0]) === null || _subDevice$mqttData4 === void 0 ? void 0 : _subDevice$mqttData4.Speed) !== null && _subDevice$mqttData$m2 !== void 0 ? _subDevice$mqttData$m2 : '0.00';
      deviceLoad = (_subDevice$mqttData$m3 = subDevice === null || subDevice === void 0 || (_subDevice$mqttData5 = subDevice.mqttData) === null || _subDevice$mqttData5 === void 0 || (_subDevice$mqttData5 = _subDevice$mqttData5.modbus[0]) === null || _subDevice$mqttData5 === void 0 ? void 0 : _subDevice$mqttData5.Load) !== null && _subDevice$mqttData$m3 !== void 0 ? _subDevice$mqttData$m3 : '0.00';
      deviceTotal = (_subDevice$mqttData$m4 = subDevice === null || subDevice === void 0 || (_subDevice$mqttData6 = subDevice.mqttData) === null || _subDevice$mqttData6 === void 0 || (_subDevice$mqttData6 = _subDevice$mqttData6.modbus[0]) === null || _subDevice$mqttData6 === void 0 ? void 0 : _subDevice$mqttData6.Total) !== null && _subDevice$mqttData$m4 !== void 0 ? _subDevice$mqttData$m4 : '0.00';
      disconnected = subDevice === null || subDevice === void 0 || (_subDevice$mqttData7 = subDevice.mqttData) === null || _subDevice$mqttData7 === void 0 || (_subDevice$mqttData7 = _subDevice$mqttData7.modbus[0]) === null || _subDevice$mqttData7 === void 0 ? void 0 : _subDevice$mqttData7.disconnected;
    }
    const {
      runningStatus
    } = this.state;
    if (deviceSpeed > 0) {
      startedDevice = true;
    }
    const handleSelectedDeviceChange = (event, val) => {
      event.preventDefault();
      const changedSid = val.props.value;
      const getIndex = devices.findIndex(e => e.sub_device.sid == changedSid);
      getIndex >= 0 && this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        deviceIndex: getIndex
      }));
    };
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 4,
      className: classes.cardParent
    }, /*#__PURE__*/React.createElement(Link, {
      id: "linkToDeviceInfo",
      to: "/Dashboard/DeviceInfo/".concat(deviceImeiNumber, "/").concat(sub_device.sid),
      style: {
        textDecoration: "none",
        color: "black"
      }
    }, /*#__PURE__*/React.createElement(Card, {
      className: classes.card,
      style: css.postionRel
    }, /*#__PURE__*/React.createElement(CardContent, {
      style: {
        padding: '15px 2px 2px 2px '
      }
    }, devices.length > 1 && /*#__PURE__*/React.createElement(Typography, {
      className: classes.conveyesCount,
      style: css.postionAbs
    }, devices.length, " Conveyers"), this.state.deviceIndex !== devices.length - 1 && /*#__PURE__*/React.createElement(Button, {
      id: "deviceIndex",
      style: css.postionAbs,
      onClick: event => this.changeIndex(event, this.state.deviceIndex + 1),
      className: classes.rightIcon,
      variant: "text",
      id: "nextIndexArrow"
    }, "\u203A"), this.state.deviceIndex !== 0 && /*#__PURE__*/React.createElement(Button, {
      style: css.postionAbs,
      onClick: event => this.changeIndex(event, this.state.deviceIndex - 1),
      className: classes.leftIcon,
      variant: "text",
      id: "leftIndexArrow"
    }, "\u2039"), /*#__PURE__*/React.createElement(Typography, {
      id: "loactionName",
      className: classes.modemName,
      gutterBottom: true,
      variant: "h5",
      component: "div"
    }, locationName), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(FormControl, {
      fullWidth: true
    }, /*#__PURE__*/React.createElement(Select, {
      id: "DashBoardModemSelectDevice",
      value: devices[this.state.deviceIndex].sub_device.sid,
      className: classes.cardDeviceDropdown,
      disableUnderline: true,
      onChange: handleSelectedDeviceChange,
      inputProps: {
        classes: {
          icon: classes.selectIcon
        }
      }
    }, devices.map(device => /*#__PURE__*/React.createElement(MenuItem, {
      key: device.sub_device.sid,
      value: device.sub_device.sid
    }, device.sub_device.sid_name))))), subDevice.loading && !this.state.timed ? pageLoader() : /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      className: disconnected ? classes.disconnected : classes.quantity
    }, disconnected ? 'Disconnected' : deviceTotal + ' t'), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      style: {
        marginBottom: "15px"
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(Box, {
      className: classes.leftBox,
      style: css.flexDirectionCol
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.mediumText,
      style: css.fontBold
    }, "Flow"), /*#__PURE__*/React.createElement(Typography, {
      style: css.wordBreak,
      className: classes.speed
    }, deviceFlow), /*#__PURE__*/React.createElement(Typography, {
      className: classes.smallText,
      style: css.fontBold
    }, "TPH"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: deviceFlow / subDevice.target_flow * 100 || 0
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React.createElement(Box, {
      style: css.flexDirectionCol,
      className: classes.rightBox
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.mediumText,
      style: css.fontBold
    }, "Speed"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.speed,
      style: css.wordBreak
    }, deviceSpeed), /*#__PURE__*/React.createElement(Typography, {
      className: classes.smallText,
      style: css.fontBold
    }, "M/S"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: deviceSpeed / (subDevice === null || subDevice === void 0 ? void 0 : subDevice.target_speed) * 100 || 0
    })))), /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 9
    }, /*#__PURE__*/React.createElement(Box, {
      mt: 2,
      sx: {
        height: "100%",
        border: '1px solid lightgrey',
        borderRadius: 25,
        padding: '15px 12px',
        marginTop: "0"
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      className: classes.mediumText
    }, "Load"), /*#__PURE__*/React.createElement(Typography, {
      className: classes.speed,
      style: css.wordBreak
    }, deviceLoad), /*#__PURE__*/React.createElement(Typography, {
      className: classes.smallText
    }, "KG/M"), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      color: "primary",
      value: deviceLoad / (subDevice === null || subDevice === void 0 ? void 0 : subDevice.target_load) * 100 || 0
    }))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 3
    }, /*#__PURE__*/React.createElement(Box, {
      mt: 2,
      className: startedDevice ? classes.deviceStatusRunning : classes.deviceStatusStopped
    }, /*#__PURE__*/React.createElement("img", {
      id: "runningStoppedImg",
      src: startedDevice ? RunningIcon : StoppedIcon,
      width: "100%",
      height: "100%",
      className: classes.imgs
    })))))))));
  }
}
const positionCss = {
  relative: "relative",
  absolute: "absolute"
};

// Customizable Area Start
export const styles = () => ({
  card: {
    // margin: '20px 28px',
    borderRadius: 20,
    boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
    padding: "20px",
    height: '100%'
  },
  cardParent: {
    padding: '15px 10px'
  },
  cardDeviceDropdown: {
    backgroundColor: '#79A1FA',
    color: 'white',
    padding: "0px 15px",
    borderRadius: 5,
    marginBottom: "10px"
  },
  rightIcon: {
    right: 0,
    top: "48%",
    padding: "9px",
    minWidth: "auto",
    fontSize: 35
  },
  leftIcon: {
    left: 0,
    top: "48%",
    padding: "9px",
    minWidth: "auto",
    fontSize: 35
  },
  conveyesCount: {
    padding: "5px 10px",
    top: 0,
    right: 0,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#79a1fa52",
    color: '#79A1FA'
  },
  modemName: {
    marginBottom: "10px"
  },
  quantity: {
    color: '#79A1FA',
    fontSize: '40px',
    fontWeight: 700
  },
  disconnected: {
    color: 'red',
    fontSize: '20px',
    marginBottom: "10px",
    fontWeight: 700
  },
  speed: {
    fontSize: '16px',
    fontWeight: 600
  },
  mediumText: {
    fontSize: '13px',
    color: 'grey'
  },
  smallText: {
    fontSize: '11px',
    color: 'grey'
  },
  leftBox: {
    border: '1px solid lightgrey',
    borderTopLeftRadius: 25,
    borderBottomLeftRadius: 25,
    padding: '15px 12px',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  rightBox: {
    border: '1px solid lightgrey',
    borderTopRightRadius: 25,
    borderBottomRightRadius: 25,
    borderLeft: 'none',
    padding: '15px 12px',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between'
  },
  deviceStatusStopped: {
    marginLeft: '25%',
    width: '70%',
    height: 120,
    marginTop: 0
  },
  deviceStatusRunning: {
    marginLeft: '25%',
    width: '70%',
    height: 120,
    marginTop: 0
  },
  selectIcon: {
    color: 'white'
  }
});
const css = {
  postionRel: {
    position: "relative"
  },
  postionAbs: {
    position: "absolute"
  },
  fontBold: {
    fontWeight: "bold"
  },
  wordBreak: {
    overflowWrap: 'break-word'
  },
  flexDirectionCol: {
    flexDirection: 'column'
  }
};
// Customizable Area End

export default withStyles(styles, {
  withTheme: true
})(DeviceStats);